import React, { useEffect, useMemo, useState } from "react";
import Moment from "react-moment";
import AddPartnerUser from "./AddPartnerUser";
import ActiveDeactiveHistory from "./ActiveDeactiveHistory";
import { useDispatch, useSelector } from "react-redux";
import { getPartnerUsers, loadPartnerUsers } from "../../app/store/partner";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../../app/store/auth";
import { getFormatedNumber } from "../../Services/appService";
import { setCurrentPageTitle, setCurrentRoute } from "../../app/store/layoutUI";
import { getAlert } from "../../Services/appAlerts";
import AddEditPermission from "./AddEditPermission";

const MANAGE_USERS_STYLES = {
  shell: {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
    marginTop: "10px"
  },
  hero: {
    borderRadius: "24px",
    padding: "22px 24px",
    border: "1px solid rgba(191, 219, 254, 0.95)",
    background: "linear-gradient(135deg, #eff6ff 0%, #ffffff 58%, #f8fafc 100%)",
    boxShadow: "0 18px 40px rgba(37, 99, 235, 0.08)"
  },
  heroRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "18px",
    flexWrap: "wrap"
  },
  heroCopy: {
    minWidth: "260px",
    flex: "1 1 480px"
  },
  heroTitleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "14px"
  },
  heroIcon: {
    width: "42px",
    height: "42px",
    borderRadius: "14px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eef2ff",
    color: "#4f46e5",
    border: "1px solid rgba(224, 231, 255, 1)",
    fontSize: "18px",
    flexShrink: 0
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.16em",
    textTransform: "uppercase",
    color: "#2563eb",
    marginBottom: "10px"
  },
  heroTitle: {
    fontSize: "20px",
    fontWeight: 800,
    lineHeight: 1.08,
    color: "#0f172a",
    margin: "0 0 5px 0"
  },
  heroText: {
    fontSize: "14px",
    lineHeight: 1.65,
    color: "#475569",
    margin: 0,
    maxWidth: "760px"
  },
  heroAction: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    padding: "10px 18px",
    fontWeight: 700,
    border: "none",
    background: "linear-gradient(135deg, #2563eb 0%, #4f46e5 100%)",
    color: "#ffffff",
    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.08)"
  },
  statGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "14px",
    marginTop: "18px"
  },
  statCard: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    backgroundColor: "#ffffff",
    border: "1px solid rgba(219, 234, 254, 1)",
    borderRadius: "18px",
    padding: "16px 18px",
    boxShadow: "0 10px 22px rgba(37, 99, 235, 0.06)"
  },
  statIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eff6ff",
    color: "#2563eb",
    flexShrink: 0
  },
  statContent: {
    minWidth: 0
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 800,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "10px"
  },
  statValue: {
    fontSize: "28px",
    fontWeight: 800,
    lineHeight: 1,
    color: "#0f172a",
    marginBottom: "6px"
  },
  statText: {
    fontSize: "13px",
    color: "#64748b",
    lineHeight: 1.5
  },
  panel: {
    backgroundColor: "#ffffff",
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "22px",
    boxShadow: "0 12px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "14px",
    padding: "18px 20px 0 20px",
    flexWrap: "wrap"
  },
  toolbarCopy: {
    minWidth: "240px",
    flex: 1
  },
  panelTitle: {
    fontSize: "20px",
    fontWeight: 800,
    color: "#0f172a",
    margin: "0 0 0 0"
  },
  panelText: {
    fontSize: "13px",
    color: "#64748b",
    margin: 0
  },
  filterRow: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap"
  },
  input: {
    minWidth: "230px",
    borderRadius: "12px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "10px 12px",
    fontSize: "13px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff"
  },
  inputWrap: {
    position: "relative"
  },
  inputIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#94a3b8",
    fontSize: "13px"
  },
  searchInput: {
    paddingLeft: "34px"
  },
  select: {
    minWidth: "160px",
    borderRadius: "12px",
    border: "1px solid rgba(203, 213, 225, 1)",
    padding: "10px 12px",
    fontSize: "13px",
    color: "#0f172a",
    outline: "none",
    backgroundColor: "#ffffff"
  },
  card: {
    borderRadius: "22px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #fcfdff 100%)",
    boxShadow: "0 14px 30px rgba(15, 23, 42, 0.05)",
    overflow: "hidden"
  },
  cardHeader: {
    padding: "20px 22px 16px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)",
    background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)"
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "16px",
    flexWrap: "wrap"
  },
  titleRow: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px"
  },
  titleIcon: {
    width: "34px",
    height: "34px",
    borderRadius: "10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#eef2ff",
    color: "#4f46e5",
    fontSize: "15px",
    border: "1px solid rgba(224, 231, 255, 1)",
    flexShrink: 0
  },
  titleText: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0
  },
  cardBody: {
    padding: "18px 22px 22px 22px"
  },
  bodyInner: {
    borderRadius: "0 0 22px 22px",
    background: "linear-gradient(180deg, #ffffff 0%, #fbfdff 100%)"
  },
  tableWrap: {
    border: "1px solid rgba(226, 232, 240, 1)",
    borderRadius: "18px",
    overflow: "auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 12px 28px rgba(15, 23, 42, 0.05)"
  },
  table: {
    marginBottom: 0,
    borderCollapse: "separate",
    borderSpacing: 0,
    fontSize: "13px",
    color: "#334155"
  },
  th: {
    borderTop: "none",
    fontSize: "12px",
    fontWeight: 800,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    background: "#f8fafc",
    padding: "14px 16px"
  },
  td: {
    padding: "14px 16px",
    borderBottom: "1px solid rgba(226, 232, 240, 1)"
  },
  statusPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 10px",
    borderRadius: "999px",
    fontSize: "12px",
    fontWeight: 700,
    border: "1px solid transparent"
  },
  rolePill: {
    display: "inline-flex",
    alignItems: "center",
    padding: "6px 10px",
    borderRadius: "999px",
    backgroundColor: "#eff6ff",
    border: "1px solid rgba(191, 219, 254, 1)",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 700
  },
  userName: {
    fontSize: "14px",
    fontWeight: 700,
    color: "#0f172a",
    marginBottom: "4px"
  },
  userMeta: {
    fontSize: "12px",
    lineHeight: 1.55,
    color: "#64748b"
  },
  userCell: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minWidth: "260px"
  },
  avatar: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #dbeafe 0%, #eef2ff 100%)",
    color: "#1d4ed8",
    border: "1px solid rgba(191, 219, 254, 1)",
    fontSize: "13px",
    fontWeight: 800,
    flexShrink: 0
  },
  actionLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "999px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    padding: "7px 12px",
    fontSize: "12px",
    fontWeight: 700,
    textDecoration: "none"
  },
  actionGroup: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap"
  },
  mutedAction: {
    fontSize: "12px",
    color: "#94a3b8",
    fontWeight: 600
  },
  emptyState: {
    padding: "28px 20px 30px 20px",
    textAlign: "center",
    color: "#64748b",
    fontSize: "14px"
  }
};

const ManagePartnerUsers = () => {
  const route = [{ name: "Administration", url: "/" }];

  const [userList, setUserList] = useState([]);
  const [actionType, setActionType] = useState("action");
  const [userDetails, setUserDetails] = useState(null);
  const [logShowHide, setLogShowHide] = useState(false);
  const [showHide, setShowHide] = useState(false);
  const [permissionShowHide, setPermissionShowHide] = useState(false);
  const [selectedObj, setSelectedObj] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");

  const userDetailsSelector = useSelector(getLoggedUserDetails);
  const partnerUsersSelector = useSelector(getPartnerUsers);


  const currentUser = getCurrentUser();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setCurrentPageTitle("Manage Users"));
    dispatch(setCurrentRoute(route))
  }, [])

  useEffect(() => {
    if (!userDetailsSelector)
      dispatch(loadUserDetails(currentUser.id));
  }, []);

  useEffect(() => {
    if (userDetailsSelector && userDetailsSelector?.partnerid) {
      setUserDetails(userDetailsSelector);
      dispatch(loadPartnerUsers(userDetailsSelector.partnerid))
    }
  }, [userDetailsSelector]);

  useEffect(() => {
    setUserList(partnerUsersSelector);
  }, [partnerUsersSelector]);

  const filteredUsers = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();

    return userList.filter((item) => {
      const matchesSearch =
        normalizedSearch === "" ||
        `${item.name || ""} ${item.lastName || ""}`.toLowerCase().includes(normalizedSearch) ||
        (item.email || "").toLowerCase().includes(normalizedSearch) ||
        (item.title || "").toLowerCase().includes(normalizedSearch) ||
        String(item.id || "").includes(normalizedSearch) ||
        (item.state || "").toLowerCase().includes(normalizedSearch);

      const matchesStatus =
        statusFilter === "all" ||
        (statusFilter === "active" && item.status === true) ||
        (statusFilter === "inactive" && item.status === false) ||
        (statusFilter === "pending" && item.status !== true && item.status !== false);

      return matchesSearch && matchesStatus;
    });
  }, [userList, searchTerm, statusFilter]);

  const activeUsersCount = userList.filter((item) => item.status === true).length;
  const inactiveUsersCount = userList.filter((item) => item.status === false).length;
  const pendingUsersCount = userList.filter((item) => item.status !== true && item.status !== false).length;

  const getUserInitials = (item) => {
    const first = item?.name ? item.name.charAt(0) : "";
    const last = item?.lastName ? item.lastName.charAt(0) : "";
    return `${first}${last}`.toUpperCase() || "U";
  };

  const handleModalShowHide = (obj) => {
    if (obj === "save") {
      setShowHide(false);
      setSelectedObj("");
      if (userDetails)
        dispatch(loadPartnerUsers(userDetails.partnerid))
    } else {
      setShowHide(!showHide);
      setSelectedObj(obj);
    }
  };

  const handlePermission = (item) => {
    setSelectedId(item.id)
    setPermissionShowHide(true);
  }

  const handlePermissionShowHide = () => {
    setSelectedId("")
    setPermissionShowHide(false)
    // setSelectedObj(null);
    // setSelectedKey("home");
    getAlert("", "Permissions Updated Successfully", "success");
  };

  const handlePermissionModalShowHide = () => {
    setSelectedId("")
    setPermissionShowHide(prev => !prev)
  };

  const handleLogShowHide = (item, type) => {
    if (item === "save") {
      setLogShowHide(false);
      setSelectedObj("");
      setActionType("action");
      if (userDetails)
        dispatch(loadPartnerUsers(userDetails.partnerid))
    } else {
      setLogShowHide(!logShowHide);
      setSelectedObj(item);
      setActionType(type);
    }
  };

  const getStatusStyles = (status) => {
    if (status === true) {
      return {
        ...MANAGE_USERS_STYLES.statusPill,
        color: "#166534",
        backgroundColor: "#f0fdf4",
        borderColor: "rgba(187, 247, 208, 1)"
      };
    }

    if (status === false) {
      return {
        ...MANAGE_USERS_STYLES.statusPill,
        color: "#b91c1c",
        backgroundColor: "#fef2f2",
        borderColor: "rgba(254, 202, 202, 1)"
      };
    }

    return {
      ...MANAGE_USERS_STYLES.statusPill,
      color: "#92400e",
      backgroundColor: "#fffbeb",
      borderColor: "rgba(253, 230, 138, 1)"
    };
  };

  return (
    <React.Fragment>
      <style>{`
        .manage-users-table thead th {
          font-size: 11px;
          font-weight: 800;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          color: #64748b;
          background: #f8fafc;
          border-bottom: 1px solid rgba(226, 232, 240, 1);
          padding-top: 14px;
          padding-bottom: 14px;
        }

        .manage-users-table tbody td {
          padding-top: 14px;
          padding-bottom: 14px;
          vertical-align: middle;
          border-top: 1px solid rgba(241, 245, 249, 1);
        }

        .manage-users-table tbody tr:hover {
          background-color: #fbfdff;
        }

        .manage-users-table {
          min-width: 980px;
        }

        .manage-users-input:focus,
        .manage-users-select:focus {
          border-color: #93c5fd !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
        }

        .manage-users-action:hover {
          text-decoration: none;
          transform: translateY(-1px);
          box-shadow: 0 8px 18px rgba(37, 99, 235, 0.08);
        }
      `}</style>

      <div style={MANAGE_USERS_STYLES.shell}>
        <div style={MANAGE_USERS_STYLES.hero}>
          <div style={MANAGE_USERS_STYLES.heroRow}>
            <div style={MANAGE_USERS_STYLES.heroCopy}>
              <div style={MANAGE_USERS_STYLES.heroTitleRow}>
                <span style={MANAGE_USERS_STYLES.heroIcon}>
                  <i className="fa fa-users" aria-hidden="true"></i>
                </span>
                <div>
                  <h1 style={MANAGE_USERS_STYLES.heroTitle}>Manage Users</h1>
                  <p style={MANAGE_USERS_STYLES.heroText}>
                    Review account access, monitor activation status, edit user records, and manage permissions from one workspace.
                  </p>
                </div>
              </div>
            </div>

            <button
              className="btn"
              style={MANAGE_USERS_STYLES.heroAction}
              onClick={() => handleModalShowHide("")}
            >
              <i className="fa fa-user-plus"></i>
              Add User
            </button>
          </div>

          <div style={MANAGE_USERS_STYLES.statGrid}>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Total Users</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{userList.length}</div>
                <div style={MANAGE_USERS_STYLES.statText}>All users currently available in this workspace.</div>
              </div>
            </div>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Active</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{activeUsersCount}</div>
                <div style={MANAGE_USERS_STYLES.statText}>Users who can currently access partner tools.</div>
              </div>
            </div>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Inactive</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{inactiveUsersCount}</div>
                <div style={MANAGE_USERS_STYLES.statText}>Users that are currently deactivated.</div>
              </div>
            </div>
            <div style={MANAGE_USERS_STYLES.statCard}>
              <div style={MANAGE_USERS_STYLES.statContent}>
                <div style={MANAGE_USERS_STYLES.statLabel}>Pending</div>
                <div style={MANAGE_USERS_STYLES.statValue}>{pendingUsersCount}</div>
                <div style={MANAGE_USERS_STYLES.statText}>Users waiting for an activation decision.</div>
              </div>
            </div>
          </div>
        </div>

        <div className="card shadow-none border-1" style={MANAGE_USERS_STYLES.card}>
          <div className="card-header border-1" style={MANAGE_USERS_STYLES.cardHeader}>
            <div style={MANAGE_USERS_STYLES.headerRow}>
              <div style={MANAGE_USERS_STYLES.titleRow}>
                <span style={MANAGE_USERS_STYLES.titleIcon}>
                  <i className="fa fa-id-card-o" aria-hidden="true"></i>
                </span>
                <div style={MANAGE_USERS_STYLES.titleText}>
                  <h2 style={MANAGE_USERS_STYLES.panelTitle}>Users</h2>
                  <p style={MANAGE_USERS_STYLES.panelText}>Search, filter, and manage users without leaving the table.</p>
                </div>
              </div>
              <div style={MANAGE_USERS_STYLES.filterRow}>
                <div style={MANAGE_USERS_STYLES.inputWrap}>
                  <i className="fa fa-search" style={MANAGE_USERS_STYLES.inputIcon}></i>
                  <input
                    className="manage-users-input"
                    type="text"
                    placeholder="Search name, email, ID, role, state"
                    value={searchTerm}
                    onChange={(event) => setSearchTerm(event.target.value)}
                    style={{ ...MANAGE_USERS_STYLES.input, ...MANAGE_USERS_STYLES.searchInput }}
                  />
                </div>
                <select
                  className="manage-users-select"
                  value={statusFilter}
                  onChange={(event) => setStatusFilter(event.target.value)}
                  style={MANAGE_USERS_STYLES.select}
                >
                  <option value="all">All statuses</option>
                  <option value="active">Activated</option>
                  <option value="inactive">Deactivated</option>
                  <option value="pending">Pending</option>
                </select>
              </div>
            </div>
          </div>
          <div className="card-body border-1" style={MANAGE_USERS_STYLES.cardBody}>
            <div style={MANAGE_USERS_STYLES.bodyInner}>
              <div className="table-responsive" style={MANAGE_USERS_STYLES.tableWrap}>
                <table className="table manage-users-table" style={MANAGE_USERS_STYLES.table}>
                  <thead className="thead-light">
                    <tr>
                      <th style={MANAGE_USERS_STYLES.th}>ID</th>
                      <th style={MANAGE_USERS_STYLES.th}>Date & Time</th>
                      <th style={MANAGE_USERS_STYLES.th}>User Details</th>
                      <th style={MANAGE_USERS_STYLES.th}>Role</th>
                      <th style={MANAGE_USERS_STYLES.th}>State</th>
                      <th style={MANAGE_USERS_STYLES.th}>Status</th>
                      <th style={MANAGE_USERS_STYLES.th}>Action</th>
                      <th style={MANAGE_USERS_STYLES.th}>Permission</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredUsers.map((item) => {
                      const isCurrentUser = userDetails?.performername === item.name;

                      const renderStatus = () => {
                        const iconStyle = { fontSize: "14px" };

                        if (item.status === true) {
                          return (
                            <span style={getStatusStyles(item.status)}>
                              <i className="fa fa-check" style={iconStyle}></i> Activated
                            </span>
                          );
                        }

                        if (item.status === false) {
                          return (
                            <span style={getStatusStyles(item.status)}>
                              <i className="fa fa-times" style={iconStyle}></i> Deactivated
                            </span>
                          );
                        }

                        return (
                          <span style={getStatusStyles(item.status)}>
                            <i className="fa fa-clock-o" style={iconStyle}></i> To Activate
                          </span>
                        );
                      };

                      const renderStatusCell = () => {
                        if (isCurrentUser) {
                          return renderStatus();
                        }

                        return (
                          <button
                            className="btn btn-link btn-sm p-0"
                            onClick={() => handleLogShowHide(item, "action")}
                            style={{ textDecoration: "none" }}
                          >
                            {renderStatus()}
                          </button>
                        );
                      };

                      return (
                        <tr key={item.id}>
                          <td style={MANAGE_USERS_STYLES.td}>{item.id}</td>
                          <td style={MANAGE_USERS_STYLES.td}>
                            <div style={MANAGE_USERS_STYLES.userName}>
                              <Moment format="MMM Do YYYY">{item.addedDateTime}</Moment>
                            </div>
                            <div style={MANAGE_USERS_STYLES.userMeta}>
                              <Moment format="h:mm a">{item.addedDateTime}</Moment>
                            </div>
                          </td>
                          <td style={MANAGE_USERS_STYLES.td}>
                            <div style={MANAGE_USERS_STYLES.userCell}>
                              <div>
                                <div style={MANAGE_USERS_STYLES.userName}>
                                  {item.name} {item.lastName}
                                </div>
                                <div style={MANAGE_USERS_STYLES.userMeta}>{item.email}</div>
                                <div style={MANAGE_USERS_STYLES.userMeta}>
                                  {item.contact ? getFormatedNumber(item.contact) : "No phone on file"}
                                </div>
                              </div>
                            </div>
                          </td>
                          <td style={MANAGE_USERS_STYLES.td}>
                            <span style={MANAGE_USERS_STYLES.rolePill}>{item.title || "User"}</span>
                          </td>
                          <td style={MANAGE_USERS_STYLES.td}>{item.state || "-"}</td>
                          <td style={MANAGE_USERS_STYLES.td}>{renderStatusCell()}</td>
                          <td style={MANAGE_USERS_STYLES.td}>
                            <div style={MANAGE_USERS_STYLES.actionGroup}>
                              <button
                                type="button"
                                className="manage-users-action"
                                title="Edit User"
                                onClick={() => handleModalShowHide(item)}
                                style={MANAGE_USERS_STYLES.actionLink}
                              >
                                <i className="fa fa-pencil"></i> Edit
                              </button>
                            </div>
                          </td>
                          <td style={MANAGE_USERS_STYLES.td}>
                            {!isCurrentUser && (
                              <div style={MANAGE_USERS_STYLES.actionGroup}>
                                <button
                                  type="button"
                                  className="manage-users-action"
                                  onClick={() => handlePermission(item)}
                                  style={MANAGE_USERS_STYLES.actionLink}
                                >
                                  <i className="fa fa-shield"></i> Permissions
                                </button>
                              </div>
                            )}
                            {isCurrentUser && (
                              <span style={MANAGE_USERS_STYLES.mutedAction}>Current user</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    {filteredUsers.length === 0 && (
                      <tr>
                        <td colSpan="8" style={MANAGE_USERS_STYLES.emptyState}>
                          No users matched the current search or status filter.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {
        selectedId &&
        <AddEditPermission
          roleid={selectedId}
          roleSource="partner"
          handlePermissionShowHide={handlePermissionShowHide}
          showHide={permissionShowHide}
          handleModalShowHide={handlePermissionModalShowHide}
        />
      }
      <AddPartnerUser
        showHide={showHide}
        handleModalShowHide={handleModalShowHide}
        currentUser={currentUser}
        selectedObj={selectedObj}
        userDetails={userDetails}
      ></AddPartnerUser>
      <ActiveDeactiveHistory
        logShowHide={logShowHide}
        handleLogShowHide={handleLogShowHide}
        selectedObj={selectedObj}
        type="performer"
        pageType="User"
        actionType={actionType}
      ></ActiveDeactiveHistory>
    </React.Fragment>
  );
}

export default ManagePartnerUsers;
